import { useCallback, useEffect, useRef, useState } from "react";
import { debounce } from "lodash";

type UseDebouncedValueReturn = [string, (val: string) => void];

const useDebouncedValue = (
  initialValue = "",
  delay = 500
): UseDebouncedValueReturn => {
  const [value, setValue] = useState<string>(initialValue);
  const setDebouncedValue = useRef(
    debounce((val: string) => {
      setValue(val);
    }, delay)
  );
  const handleChange = useCallback(
    (val: string) => {
      setDebouncedValue.current(val);
    },
    [setDebouncedValue]
  );
  useEffect(() => {
    const debounceCb = setDebouncedValue.current;
    return () => {
      debounceCb.cancel();
    };
  }, []);
  return [value, handleChange];
};

export default useDebouncedValue;
